import { EarnSection } from '@/components/dashboard/EarnSection'

export function EarnPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <EarnSection />
    </div>
  )
}
